import { useEffect } from 'react';
import socket from '../../../../../utils/socket';

/**
 * Custom hook to manage real-time reader telemetry & door status socket subscriptions.
 *
 * @param {object} params
 * @param {string} params.selectedBuildingId - Selected building ID
 * @param {function} params.setDoors - State setter function for doors list
 */
export const useReaderTelemetrySocket = ({ selectedBuildingId, setDoors }) => {
  useEffect(() => {
    if (!selectedBuildingId) return;

    socket.emit('subscribe:door_status', { buildingId: selectedBuildingId });

    const eventName = `door_update_${selectedBuildingId}`;
    const handleDoorUpdate = ({ doorId, localId, event }) => {
      setDoors((prevDoors) =>
        prevDoors.map((door) => {
          const isMatch =
            (doorId && String(door.id) === String(doorId)) ||
            (localId !== undefined && String(door.localId) === String(localId));

          if (isMatch) {
            return {
              ...door,
              masterStatus: event?.masterStatus ?? door.masterStatus,
              slaveStatus: event?.slaveStatus ?? door.slaveStatus,
              masterSpiOk: event?.masterSpiOk ?? door.masterSpiOk,
              slaveSpiOk: event?.slaveSpiOk ?? door.slaveSpiOk,
              status: event?.eventType ?? door.status,
            };
          }
          return door;
        })
      );
    };

    socket.on(eventName, handleDoorUpdate);
    return () => {
      socket.off(eventName, handleDoorUpdate);
    };
  }, [selectedBuildingId, setDoors]);
};

export default useReaderTelemetrySocket;
